import { NgModule } from 'ng-metadata/core';
import {StaticService} from './static.service';
import {PrmStatic} from './static.directive';
import {PrmStaticPage} from './staticPage';
import {PrmEmailTemplate} from "../emailTemplate/emailTemplate.directive";

@NgModule({
    declarations: [
        PrmStatic,
        PrmStaticPage,
        PrmEmailTemplate
    ],
    providers: [
        StaticService
    ],
    imports:[

    ]
})
export class StaticModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/static/static.module.ts